module.exports = __webpack_public_path__ + "static/media/shield-cracked.d48ab340.webp";